import ServicePlanAsset from "./ServicePlanAsset";
import _Model from "./_Model";

export default class ServicePlanItem extends _Model {
  constructor(json) {
    super(json);
    this.id = ServicePlanItem.getOrDefault(json, 'id', '');
    this.quantity = ServicePlanItem.getMappedOrDefault(json, 'quantity', 0, v => parseInt(v));
    this.licenceType = ServicePlanItem.getOrDefault(json, 'licenceType', '');
    this.licenceGroup = 'service_plan';
    this.licenseModel = ServicePlanItem.getOrDefault(json, 'licenseModel', null);
    this.description = ServicePlanItem.getOrDefault(json, 'description', '');
    this.title = ServicePlanItem.getOrDefault(json, 'title', '');
    this.labelKey = ServicePlanItem.getOrDefault(json, 'labelKey', '');
    this.servicePlanAssets = ServicePlanItem.getMappedOrDefault(json, 'servicePlanAssets', [], data => (data || []).map(a => new ServicePlanAsset(a)));
  }
}
